var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"has-background-white rounded-lg px-lg py-md mb-lg"},[_c('Onboarding',{attrs:{"connection":_vm.connection}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }